
import { reactive, computed, watch, onMounted, nextTick } from 'vue';
import { uuid } from 'vue-uuid';
export default {
  components: {},
  props: {
    text: {
      type: String,
      default: '',
    },
    isCheck: {
      type: [Boolean,String, Number],
      default: false,
    },
    isSlot: {
      type: Boolean,
      default: false, //文字部分是否要用slot (預設直接傳text)
    },
    value: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: 'default'
    },
    layout: {
      type: String,
      default: 'block',  //block : 自己一行 , inline : 多個一行
    },
    size: {
      type: String,
      default: 'md', // md: 24px, sm: 16px --> for table
    },
    isError: {
      type: Boolean,
      default: false,
    },
    isDisable: {
      type: Boolean,
      default: false,
    },
    isFlex: {
      type: Boolean,
      default: false,
    },
    isI18n: {
      type: String,
      default: '',
    },
    padding: {
      type: String,
      default: '0px',
    },
    hoverEffect: {
      type: Boolean,
      default: false,
    }
  },
  setup(props, { emit }) {
    const { isCheck, text, layout, size, isError, isDisable, isSlot } = props;
    const state = reactive({
      id: uuid.v4(),
      myVal: isCheck,
      errorStyle: '',
      disableStyle: '',

    })
    const privateIsChecked = computed({
      get: () => { return isCheck },
      set: (val) => {
        // state.myVal = val
        emit('update:isCheck', val);
      }
    })
    watch(
      () => props.isCheck,
      (n) => {
        emit('onBeforeChange', n);
      }
    )
    watch(
      () => props.isError,
      (val) => {
        state.errorStyle = val ? 'style--error' : '';
      })

    watch(
      () => props.isDisable,
      (val) => {
        state.disableStyle = val ? 'style--disable' : '';
      })
    const init = () => {
      state.errorStyle = isError ? 'style--error' : '';
      state.disableStyle = isDisable ? 'style--disable' : '';
    }
    onMounted(() => {
      init();
    })

    const   onClickKeypress = () => {
      nextTick(()=>{
        document.getElementById(state.id).click()
      })
    }



    const onChange = (val) => {
      emit('onChange', val);
    }

    const classStyle = computed(() => [
      {
        'style--has-text': text != ''
      },
      {
        'style--slot': isSlot
      },
      'style--' + layout,
      'style--' + size,
    ])


    return {
      state,
      privateIsChecked,
      classStyle,
      onChange,
      onClickKeypress
    }
  }// end: setup
}


